import React from "react";
import { PeekBox, PeekDivider, PeekList, PeekListItem, PeekListItemButton, PeekListItemText, PeekPaper, useTheme, } from "@piiqtechnologies/ui-components";
export const AiDiscoverabilityResultNavigation = ({ sections, activeSection, onSectionClick, }) => {
    const theme = useTheme();
    const handleLogoClick = () => {
        window.open("https://www.peek.us/", "_blank", "noreferrer");
    };
    return (React.createElement(PeekPaper, { elevation: 0, sx: {
            width: 140,
            position: "sticky",
            top: 0,
            height: "100%",
            flexShrink: 0,
            backgroundColor: "transparent",
        } },
        React.createElement(PeekList, { sx: { pt: 1 } },
            React.createElement(PeekBox, { component: "img", sx: {
                    width: "100%",
                    height: "auto",
                    p: 1.8,
                    cursor: "pointer",
                }, 
                // @ts-ignore
                src: "/images/peek_discover_dark_logo.svg", alt: "Peek Logo", onClick: handleLogoClick }),
            React.createElement(PeekDivider, { sx: { m: 1, mr: "50%", mb: 2 }, light: true }),
            sections.map((section) => {
                const isActive = activeSection === section.id;
                return (React.createElement(PeekListItem, { key: section.id, disablePadding: true, sx: {
                        height: theme.spacing(4),
                    } },
                    React.createElement(PeekListItemButton, { onClick: () => onSectionClick(section.id), sx: {
                            borderLeft: isActive ? `1px solid ${theme.palette.primary.main}` : "none",
                            height: theme.spacing(2.6),
                            "&.Mui-selected": {
                                fontWeight: 600,
                            },
                        } },
                        React.createElement(PeekListItemText, { primary: section.label, primaryTypographyProps: {
                                variant: "h4",
                                fontWeight: isActive ? 600 : 400,
                            } }))));
            }))));
};
export default AiDiscoverabilityResultNavigation;
